import { useState } from 'react';
import { Navigate, useLocation } from 'react-router';

import { AuthStateType, useAuth } from '../../hooks/useAuth';
import { usePageTitle } from '../../hooks/usePageTitle';
import { getSafeFromLocation } from '../../utils/navigation';
import { LayoutWithBgGradient } from '../LayoutWithBgGradient';
import { PageHeaderWithUser } from '../PageHeaderWithUser';

import { Confirm } from './Confirm';
import { Create } from './Create';
import { FormData as IndividualFormData } from './individual/FormData';
import { FormData as OrgFormData } from './organization/FormData';

interface Props {
  className?: string;
}

export function CreateProfilePage(props: Props) {
  const [auth, { refreshUser }] = useAuth();
  const location = useLocation();
  const [formData, setFormData] = useState<
    OrgFormData | IndividualFormData | null
  >(null);
  const [showConfirm, setShowConfirm] = useState(false);

  usePageTitle('Create Profile | Publishing Portal');

  if (
    auth.type === AuthStateType.Authenticated &&
    !showConfirm &&
    (auth.user.onboardingState === 'Complete' ||
      auth.user.onboardingState === 'KYB')
  ) {
    return (
      <Navigate
        to={getSafeFromLocation(location.state?.from) ?? '/dashboard'}
        replace
      />
    );
  }

  const handleFormComplete = (data: OrgFormData | IndividualFormData) => {
    setFormData(data);
    setShowConfirm(true);
    void refreshUser();
  };

  return (
    <LayoutWithBgGradient className={props.className}>
      <div className="h-screen w-screen overflow-y-auto">
        <PageHeaderWithUser />
        {!showConfirm ? (
          <Create
            className="px-8 max-w-2xl w-full mx-auto mt-12"
            onComplete={handleFormComplete}
            initialFormData={formData}
          />
        ) : formData ? (
          <Confirm
            className="px-8 max-w-2xl w-full mx-auto mt-12"
            formData={formData}
          />
        ) : null}
      </div>
    </LayoutWithBgGradient>
  );
}
